module.exports = __webpack_public_path__ + "static/media/test-server.af5b1786.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/test-server.jpeg
// module id = 876
// module chunks = 0